"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shipmentDetails = void 0;
var Ceramic = __importStar(require("@amzn/ceramic-jsx"));
var ceramic_jsx_1 = require("@amzn/ceramic-jsx");
var ceramic_components_1 = require("@amzn/ceramic-components");
var Utils_1 = require("../assets/scripts/Utils");
var Constants_1 = require("../constants/Constants");
var SummaryPage_1 = require("./SummaryPage");
var HistoryPage_1 = require("./HistoryPage");
var state = new Utils_1.ShipmentDetailsPageState();
var rowData;
exports.shipmentDetails = (Ceramic.createCeramicElement(ceramic_jsx_1.Page, { id: "ShipmentDetailsPageId", version: "1.0.0", imports: [
        Utils_1.Utils.__import
    ], dataSources: [
        {
            name: 'state',
            inlineData: state
        }
    ], assets: {
        templates: {
            "Tab": (Ceramic.createCeramicElement(ceramic_components_1.Tab, { title: '', tabId: '', tabIndex: 0, tabSize: '100%', extraInfo: null })),
        }
    } },
    Ceramic.createCeramicElement(ceramic_jsx_1.ActionBar, { title: "Shipment Details", showAppIcon: true }),
    Ceramic.createCeramicElement(ceramic_jsx_1.LinearContainer, { id: "ShipmentDetailPageMainContainer", orientation: "vertical", height: "fill", width: "fill", backgroundColor: Constants_1.ShipmentDetailsPageColors.pageBackgroundColor },
        Ceramic.createCeramicElement(ceramic_components_1.Hero, { title: function () { return rowData.id; }, secondaryText: function () { return rowData.amazonId; } }),
        Ceramic.createCeramicElement(ceramic_jsx_1.LinearContainer, { id: "ShipmentDetailPageTabsContainer", height: 'fill', width: 'fill' },
            Ceramic.createCeramicElement(ceramic_components_1.Tabs, { id: 'TopTabs', width: "fill", activeTabIndex: state.activePage == 'summary' ? 0 : 1, tabs: [
                    { title: 'Summary', tabId: 'summary' },
                    { title: 'History', tabId: 'history' }
                ], onTabSelect: function (tabId) {
                    return function (tabId) {
                        state.activePage = tabId;
                    };
                } }),
            Ceramic.createCeramicElement(SummaryPage_1.SummaryPage, { visibility: function (state) {
                    if (state.activePage == 'summary') {
                        return 'visible';
                    }
                    else {
                        return 'gone';
                    }
                } }),
            Ceramic.createCeramicElement(HistoryPage_1.HistoryPage, { visibility: function (state) {
                    if (state.activePage == 'history') {
                        return 'visible';
                    }
                    else {
                        return 'gone';
                    }
                } })))));
exports.default = (0, ceramic_jsx_1.render)(exports.shipmentDetails);
